import { z } from 'zod';

export const customFoodMigrationStatusSchema = z.enum(['pending', 'applied', 'ignored']);
export type CustomFoodMigrationStatus = z.infer<typeof customFoodMigrationStatusSchema>;

export const customFoodMigrationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  customFoodId: z.string(),
  customFoodName: z.string(),
  systemFoodId: z.string(),
  systemFoodName: z.string(),
  status: customFoodMigrationStatusSchema,
  customFoodIsShared: z.boolean().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CustomFoodMigration = z.infer<typeof customFoodMigrationSchema>;

export const customFoodMigrationDocSchema = customFoodMigrationSchema.extend({
  customFoodIsShared: z.boolean(),
});
export type CustomFoodMigrationDocType = z.infer<typeof customFoodMigrationDocSchema>;
